
import { Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface TicketDatesProps {
  createdAt: string;
  updatedAt: string;
}

export default function TicketDates({ createdAt, updatedAt }: TicketDatesProps) {
  const { t } = useTranslation();
  const formatDate = (dateStr: string) => {
    // Parse the UTC date and adjust for Myanmar timezone (+06:30)
    const utcDate = new Date(dateStr);
    
    return utcDate.toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true // Ensure 12-hour format with AM/PM
    });
  };

  return (
    <div className="flex flex-col text-sm text-gray-500">
      <div className="flex items-center">
        <Calendar className="h-4 w-4 mr-1" />
        <span>{t('tickets.created')}: {new Date(createdAt).toLocaleString(undefined, {
                      month: 'short',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true // Ensure 12-hour format with AM/PM
                    })}</span>
      </div>
      <div className="mt-1 flex items-center">
        <Calendar className="h-4 w-4 mr-1" />
        <span>{t('tickets.lastUpdated', 'Last Updated')}: {formatDate(updatedAt)}</span>
      </div>
    </div>
  );
}